import React from 'react';
import './Recruits.css';
import recruitsimg from '../../../assets/Students/recruits-img.png';
import { Link } from 'react-router-dom';

function Recruits() {
    return (
        <div className='recruits-outer'>
            <div className="recruits-inner">
                <div className="recruits-left">
                    <div className="recruits-left-inner">
                        <img src={recruitsimg} alt="" loading='lazy'/>
                        <p className='paragraph-text'>
                            Over the span of 13 years LIMS Insitute of Hotel Management has placed over 3000+ students in different sectors.
                        </p>
                    </div>
                </div>
                <div className="recruits-right">
                    <div className="recruits-upper">
                        <h2 className='secondary-header'>Who was our top recruiter over the last decade?</h2>
                        <button className='d-flex align-items-center justify-content-center cta-text'>
                            <i className='bx  bx-play-circle'></i>
                            <p><Link to='/placements'>Check Our Students</Link></p>
                        </button>
                    </div>
                    <div className="recruits-lower">
                        <p><span className='ninety-two'>92</span><span className='percentage'>%</span></p>
                        <p className='student'>Students were <span className='orange'>placed</span> all around the <span className='orange'>globe</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Recruits
